import { render, staticRenderFns } from "./IconsCard.vue?vue&type=template&id=3ae08a0c&scoped=true&"
import script from "./IconsCard.vue?vue&type=script&lang=js&"
export * from "./IconsCard.vue?vue&type=script&lang=js&"
import style0 from "./IconsCard.vue?vue&type=style&index=0&id=3ae08a0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae08a0c",
  null
  
)

export default component.exports